document.getElementById("menu-toggle")?.addEventListener("click", function(e) {
    e.preventDefault();
    document.getElementById("wrapper").classList.toggle("toggled");
});
document.getElementById("menu-toggle-2")?.addEventListener("click", function(e) {
    e.preventDefault();
    document.getElementById("wrapper").classList.toggle("toggled-2");
    document.querySelectorAll("#menu ul").forEach(function(el) { el.style.display = "none"; });
});

var sidebarWrapper = document.getElementById("sidebar-wrapper");
if (sidebarWrapper) {
    sidebarWrapper.addEventListener("mouseenter", function() {
        document.querySelectorAll(".toggled-2 .left-side-toggle").forEach(function(el) { el.classList.add("post-hover"); });
    });
    sidebarWrapper.addEventListener("mouseleave", function() {
        document.querySelectorAll(".toggled-2 .left-side-toggle").forEach(function(el) { el.classList.remove("post-hover"); });
    });
}

function readURL(input) {
    if (input.files && input.files[0]) {
        var reader = new FileReader();
        reader.onload = function(e) {
            var imagePreview = document.getElementById("imagePreview");
            if (imagePreview) {
                imagePreview.style.backgroundImage = "url(" + e.target.result + ")";
                imagePreview.style.display = "none";
                imagePreview.style.display = "block";
            }
        };
        reader.readAsDataURL(input.files[0]);
    }
}
document.getElementById("imageUpload")?.addEventListener("change", function() {
    readURL(this);
});
